import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from "mobx-react"

import fieldTypes from '../data/fieldTypes.json'

@inject("store")
@observer
export default class FieldDeletor extends React.Component {
  render() {
    const { store } = this.props

    return (
      <i className="fa fa-trash"
        title="Delete Field"
        style={{cursor: 'pointer'}}
        onClick={() => store.removeField(this.props.fieldGroupIndex, this.props.fieldIndex)}
        />
    )
  }
}

React.propTypes = {
  field: PropTypes.object.required,
  fieldIndex: PropTypes.number.required,
  fieldGroupIndex: PropTypes.number.required
}
